import { gql } from '@apollo/client';

// Shared with the Consumer server preload, which must use the same variables
export const DEFAULT_SELLER_REVIEWS_SORT = 'highest';

export const GET_SELLER_REVIEWS = gql`
  query getSellerReviews($sortBy: String, $page: Int) {
    sellerReviews: getSellerReviews(sortBy: $sortBy, page: $page) {
      total
      hasMore
      averageRating
      reviews {
        id
        title
        full_name
        location
        comment
        rate
        date
      }
    }
  }
`;
